const SUCCESS_STATUSES = new Set([
    'completed',
    'active',
    'success',
    'custom',
    'approved',
    'applied',
    'accepted',
    'published',
    'ready',
    'enabled',
    'resolved',
    'verified',
    'passed',
    'tamamlandı',
    'tamamlandi',
]);

const WARNING_STATUSES = new Set([
    'planned',
    'pending',
    'warning',
    'stale',
    'shadow',
    'submitted',
    'pending approval',
    'pending_approval',
    'pending-approval',
    'awaiting approval',
    'on hold',
    'on_hold',
    'on-hold',
    'paused',
    'waiting',
    'queued',
    'returned',
    'incomplete',
]);

const INFO_STATUSES = new Set([
    'in progress',
    'in_progress',
    'processing',
    'running',
    'open',
    'assigned',
    'reassigned',
    'in approval',
    'in_approval',
    'under review',
    'under_review',
    'under-review',
    'devam ediyor',
]);

const DESTRUCTIVE_STATUSES = new Set([
    'cancelled',
    'canceled',
    'failed',
    'destructive',
    'blocked',
    'delayed',
    'overdue',
    'rejected',
    'denied',
    'error',
    'expired',
    'iptal',
    'iptal edildi',
]);

const NEUTRAL_STATUSES = new Set([
    'inactive',
    'suppressed',
    'off',
    'inherit',
    'locked',
    'draft',
    'not started',
    'not_started',
    'disabled',
    'closed',
    'archived',
    'skipped',
]);

/**
 * Map a status string or explicit variant to a StatusBadge tone key.
 */
export function getStatusBadgeTone(status, variant) {
    if (!status) {
        return variant || 'neutral';
    }

    const low = String(status).toLowerCase().trim();
    if (SUCCESS_STATUSES.has(low)) return 'success';
    if (WARNING_STATUSES.has(low)) return 'warning';
    if (INFO_STATUSES.has(low)) return 'info';
    if (DESTRUCTIVE_STATUSES.has(low)) return 'destructive';
    if (NEUTRAL_STATUSES.has(low)) return 'neutral';
    return variant || 'neutral';
}
